import { render, staticRenderFns } from "./FlashCardSetCard.vue?vue&type=template&id=a4c503fa&"
import script from "./FlashCardSetCard.vue?vue&type=script&lang=js&"
export * from "./FlashCardSetCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports